import styled from 'styled-components'

const StyledModalRenegociacaoComposicaoCarga = styled.div`
  padding-bottom: .4rem;
`
export default StyledModalRenegociacaoComposicaoCarga
